import i18n from '@/langs'
import type { RouteRecordRaw } from 'vue-router'

const AccountSettingsView = () => import('@/views/Settings/Account/Index.vue')
const AssistantFundView = () => import('@/views/Assistant/Index.vue')
const AssistantFundDetail = () =>
  import('@/views/Assistant/AssistantFundDetail.vue')
const OnePagerLayout = () => import('@/layouts/OnePager.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: OnePagerLayout,
    meta: {
      name: i18n.global.t('ui.common.dashboard'),
    },
    children: [
      {
        path: '/',
        name: 'AssistantFundView',
        component: AssistantFundView,
        meta: {
          name: i18n.global.t('ui.common.fund'),
        },
        children: [
          {
            path: ':client_relation_id',
            name: 'AssistantFundDetail',
            component: AssistantFundDetail,
            props: true,
          },
        ],
      },
      {
        path: '/account-settings',
        name: 'AccountSettingsView',
        component: AccountSettingsView,
        meta: {
          name: i18n.global.t('ui.common.account_settings'),
        },
      },
    ],
  },
]

export default routes
